import request from "@/utils/request";
import { TMPURL } from "./config";

// 微信自动登录
export function weichatAutoLogin(params) {
	return request.get(TMPURL + "/v1/public/login/autologin", params);
}

// 手机/邮箱登录
export function apiLogin(params) {
	let url = "/v1/public/login/byphone";
	if (params && params.email) {
		url = "/v1/public/login/byemail";
	}
	return request.post(TMPURL + url, params, true, true);
}

// 手机登录
export function loginByPhone(params) {
	return request.post(
		TMPURL + "/v1/public/login/byphone",
		params,
		true,
		true
	);
}

// 邮箱登录
export function loginByEmail(params) {
	return request.post(
		TMPURL + "/v1/public/login/byemail",
		params,
		true,
		true
	);
}

// 获取短信/邮箱验证码
export function apiGetLoginCode(params) {
	let url = "/v1/public/login/sendSms";
	if (params && params.email) {
		url = "/v1/public/login/sendMailCode";
	}
	return request.post(TMPURL + url, params, true, true);
}

// 获取短信验证码
export function getPhoneCode(params) {
	return request.post(
		TMPURL + "/v1/public/login/sendSms",
		params,
		true,
		true
	);
}

// 获取邮箱验证码
export function getEmailCode(params) {
	return request.post(
		TMPURL + "/v1/public/login/sendMailCode",
		params,
		true,
		true
	);
}

// 注销
export function logout(params) {
	return request.post(TMPURL + "/v1/public/logout", params, true, true);
}

// 获取用户信息
export function apiGetUserInfo(params) {
	return request.get(TMPURL + "/v1/frontend/login/getUserInfo", params);
}

// 获取绑定角色
export function getRoleList(params) {
	return request.get(TMPURL + "/v1/frontend/role/getRole", params);
}

// 获取SDK角色
export function getSdkRoleList(params) {
	return request.get(TMPURL + "/v1/frontend/role/getSdkRole", params);
}

// 获取区服类型
export function getServerTypeList(params) {
	return request.get(TMPURL + "/v1/public/select/serverType", params);
}

// 获取区服名称
export function getServerList(params) {
	return request.get(TMPURL + "/v1/public/select/getServerList", params);
}

// 绑定角色
export function bindRoles(params) {
	return request.post(
		TMPURL + "/v1/frontend/role/bindRole",
		params,
		true,
		true
	);
}

// 游客登录
export function apiGuestLogin(params) {
	return request.post(TMPURL + "/v1/public/login/guest", params, true, true);
}

// 设置默认角色
export function apiGuestRoleDefault(params) {
	return request.post(TMPURL + "/v1/public/role/default", params, true, true);
}

// 获取默认角色
export function getDefaultRole(params) {
	return request.get(TMPURL + "/v1/frontend/role/getDefaultRole", params);
}

// 切换角色
export function userChooseRole(params) {
	return request.post(TMPURL + "/v1/frontend/role/chooseRole", params);
}

// 获取自助服务列表
export function apiGetSelfFormList(params) {
	return request.get(
		TMPURL + "/v1/public/selfService/getSelfFormList",
		params
	);
}

// 获取图形验证码
export function apiGetCaptchaCode(params) {
	return request.get(TMPURL + "/v1/public/login/captcha", params);
}

// 发送游戏邮件
export function apiSendGameMail(params) {
	return request.post(
		TMPURL + "/v1/public/role/sendGameMail",
		params,
		true,
		true
	);
}

// 获取解绑验证码
export function apiGetReBindCode(params) {
	return request.post(
		TMPURL + "/v1/frontend/selfService/sendBindVerifyCode",
		params,
		true,
		true
	);
}

// 手机换绑
export function apiRemoveBindPhone(params) {
	return request.post(
		TMPURL + "/v1/frontend/selfService/changeBindPhone",
		params,
		true,
		true
	);
}

// 手机换绑获取唯一code
export function apiGetBindPhoneCode(params) {
	return request.post(TMPURL + "/v1/frontend/selfService/getCode", params);
}

// 查询封禁详情
export function apiGetBanInfo(params) {
	return request.post(TMPURL + "/v1/frontend/selfService/queryBan", params);
}

// 查询返利信息
export function apiGetReBateInfo(params) {
	return request.get(TMPURL + "/v1/public/rebate/info", params, false, false);
}

// 查询道具流水
export function apiGetPropsFlow(params) {
	return request.post(TMPURL + "/v1/frontend/selfService/queryFlow", params);
}

// 获取登录背景
export function apiGetLoginBg(params) {
	return request.get(TMPURL + "/v1/public/login/index", params);
}

// 获取道具查询类型
export function apiGetPropCategory(params) {
	return request.get(
		TMPURL + "/v1/public/selfService/getPropCategory",
		params
	);
}

// 验证手机是否发送短信
export function isPhoneSendMsg(params, errNotice = true) {
	return request.post(
		TMPURL + "/v1/frontend/selfService/checkMsg",
		params,
		errNotice
	);
}

// 发送手机验证码
export function sendVerifyCode(params) {
	return request.post(
		TMPURL + "/v1/frontend/selfService/sendVerifyCode",
		params,
		true,
		true
	);
}

// 手机换绑
export function selfChangePhone(params) {
	return request.post(
		TMPURL + "/v1/frontend/selfService/changePhone",
		params,
		true,
		true
	);
}

// 解码数据
export function apiGameLogin(params) {
	return request.get(TMPURL + "/v1/public/login/sdkLoginNew", params);
}

// 摸鱼社
export function apiMoyuSdkLogin(params) {
	return request.get(TMPURL + "/v1/public/login/sdkMoyuLogin", params);
}

// 获取微信用户信息
export function apiWechatLogin(params) {
	return request.post(TMPURL + "/v1/public/login/wechat", params);
}

// 获取sdk绑定scheme
export function apiGetSdkScheme(params) {
	return request.post(TMPURL + "/v1/frontend/role/usdk/getScheme", params);
}

// 邮箱校验
export function apiVerifyEmail(params) {
	return request.post(TMPURL + "/v1/frontend/role/verify", params);
}
